<template>
  <b-modal
      v-model="visible"
      title="گزارش نوتیفیکیشن های ارسالی"
      cancel-variant="outline-secondary"
      centered
      hide-footer
      :no-close-on-backdrop="true"
      size="xl"
  >
    <vue-apex-charts type="line" height="400" :options="chartOptions" :series="series" />
  </b-modal>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: "notificationReport",
  props: {
    show: { type: Boolean, default: false },
    report: { type: Array, default: [] },
  },
  components: { VueApexCharts },
  data() {
    return {
      loading: false,
      items: {
        All: 'تعداد کل کاربران',
        InQueue: 'درصف',
        Failed: 'ناموفق',
        Successful: 'ارسال شده',
        Delivery: 'رسیده به کاربر',
        Click: 'کلیک شده توسط کاربر',
        RemovedApplication: 'حذف اپلیکیشن توسط کاربر',
        WithoutFireBaseToken: 'بدون توکن فایربیس'
      },
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(val) {
        return this.$emit('update:show', !!val)
      }
    },
    series() {
      let items = {}
      Object.keys(this.items).forEach(key => {
        items[key] = {
          name: this.items[key],
          data: []
        }
      })
      if (this.report)
        this.report.forEach(item => {
          Object.keys(item).forEach(key => {
            if (items[key]) items[key].data.push(item[key])
          })
        })
      return Object.values(items)
    },
    chartOptions() {
      return {
        chart: {
          type: 'line',
          fontFamily: 'IranSans',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2,
          curve: 'straight',
          dashArray: [0, 0, 0]
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: this.report ? this.report.map(item => this.$moment(item.Date).format('jM/jDD')) : [],
        },
        tooltip: {
          followCursor: true,
          x: {
            show: false
          },
        },
        grid: {
          borderColor: '#f1f1f1',
        }
      }
    }
  }
}
</script>

<style>
.apexcharts-legend-text {
  margin-left: 5px !important;
}
</style>